import React from 'react';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { getPublishedBlogs } from '../../services';
import BlogListing from '@/containers/BlogListing';
import Layout from '@/components/Layout';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const AdditionalPageContainer = (props) => {
  const advCustomSeo = props.advCustomSeoDetails;
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  return (
    <Layout
      store={storeInfo}
      title={`Blogs - ${storeInfo?.store_info?.name}`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        advCustomSeo?.description ||
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGTitle={advCustomSeo?.og_title?.value || null}
      OGDescription={advCustomSeo?.og_description || null}
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <BlogListing {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  let propData = {
    catalogCategories: [],
    blogList: null,
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['advancedSeo', 'additionalPagesList'],
    advancedSeoReqConfigs: {
      type: 'additional_page',
      typeId: propData?.blogList?.page_id,
    },
  });

  if (propType?.ssrStore?.storeReducer?.store?.store_id) {
    const _addpageResponse = await getPublishedBlogs(
      propType?.ssrStore?.storeReducer?.store?.store_id
    );
    if (_addpageResponse?.length) {
      propData.blogList = _addpageResponse ?? [];
    } else {
      ctx.res.writeHead(302, { location: '/404' });
      ctx.res.end();
      return;
    }
  }

  propData = { ...propData, ...(propType || {}) };
  const extraProps = getRequiredCtxProps(ctx, propType);

  return { props: { ...propData, ...extraProps } };
}

export default AdditionalPageContainer;
